import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtINR = (n) => {
  const x = Number(n || 0);
  return "₹" + x.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const resolveAssetUrl = (urlOrPath) => {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://") || urlOrPath.startsWith("data:")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return BACKEND_URL + urlOrPath;
  return urlOrPath;
};

export const uploadLogo = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload/logo", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, url }
};
